import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=9b036db6&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=9b036db6&prod&lang=scss&"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=9b036db6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports